import React from 'react';
import classNames from 'classnames';

const IconImage = ({ alertAnimationOn, moduleScn, moduleIdx, modelNm, areaNm }) => {
  const alertIconClassName = classNames('alert-animation', 'moduleicon');
  const hideIconClassName = classNames('moduleicon-hide-animation', 'moduleicon');
  const hideTextClassName = classNames('moduleicon-hide-animation', 'titleNum');

  return (
    <>
      {
        alertAnimationOn && <img className={alertIconClassName} src='' alt="icon" />
      }
      <img className={hideIconClassName} src='' alt="icon" title={areaNm} />
      {
        // 황산누액장치 3개는 타입은 pH건식이지만 실제는 누액장치이므로 해당되지 않는다
        (moduleScn === "2" || (moduleScn === "5" && (moduleIdx !== 118 && moduleIdx !== 119 && moduleIdx !== 120))) && (
          <div className={hideTextClassName}>{moduleScn === "2" ? 'W': 'D'}{modelNm.replace(/([\D])+/gi, '')}</div>
        )
      }
    </>
  )
}

export default IconImage;